import { EzLandingsTrackerClient } from '.'
import { DATA_EVENT_SCROLLABLE } from './constants'

// Scrollable elements using data-vars-event-scrollable can either have value as 'true' or
// string that's used for event id property value.
const getEventIdValue = target => {
  const dataAttribute = target.getAttribute(DATA_EVENT_SCROLLABLE)

  return dataAttribute && dataAttribute !== 'true' ? dataAttribute : target.id
}

const observerCallback = (entries, observer) =>
  entries.forEach(entry => {
    if (!entry.isIntersecting || !entry.target) {
      return
    }

    EzLandingsTrackerClient.trackScroll({ value: getEventIdValue(entry.target) })
    observer.unobserve(entry.target)
  })

export const setScrollEventTracker = () => {
  const observer = new IntersectionObserver(observerCallback, { threshold: 0.2 })

  document
    .querySelectorAll(`[${DATA_EVENT_SCROLLABLE}], section:not([${DATA_EVENT_SCROLLABLE}])`)
    .forEach(target => observer.observe(target))
}
